import React from "react";
import "./LoadingScreen.css";

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loading-text">LOADING_</div>
    </div>
  );
};

export default LoadingScreen;
